export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_03.a3d20209.mp4";